import { Form, Formik } from "formik"
import { useMemo } from "react"
import { useTranslation } from "react-i18next"

import Button from "@/components/Button/Button"
import SaveEditButton from "@/components/CrudButtons/SaveEditButton"
import { MODALS } from "@/constants/modals"
import { useEditProjectMutation } from "@/queries/mutations/projectMutations"
import type { StudentProject } from "@/types/projectTypes"
import { useStore } from "@/zustand/store"
import ProjectsInputes from "./ProjectsInputes"

export default function ProjectEdit() {
  const { t } = useTranslation()

  const editModalState = useStore((state) => state.editModalState)

  const project = useStore((state) => state.modalsStates[MODALS.projects.edit])

  const editProjectMutation = useEditProjectMutation()

  const initialValues = useMemo(() => {
    if (!project) return {} as StudentProject
    return {
      ...project,
    }
  }, [project])

  return (
    <>
      <Formik
        initialValues={initialValues}
        enableReinitialize
        onSubmit={(values) => {
          editProjectMutation.mutate(values, {
            onSuccess: () => editModalState(MODALS.projects.edit, undefined),
          })
        }}
      >
        {({ values }) => {
          return (
            <Form>
              <ProjectsInputes />
              <div className="d-flex justify-content-end gap-3 mt-3">
                <Button
                  type="button"
                  onClick={() =>
                    editModalState(MODALS.projects.edit, undefined)
                  }
                  variant={"secondary_border"}
                >
                  {t("buttons.cancel")}
                </Button>

                <SaveEditButton
                  initialValues={initialValues}
                  currentValues={values}
                  isLoading={editProjectMutation.isPending}
                />
              </div>
            </Form>
          )
        }}
      </Formik>
    </>
  )
}
